<template>
  <el-carousel
    :interval="5000 * 2"
    arrow="always"
    indicator-position="none"
    class="carousel-social-preview"
  >
    <el-carousel-item v-for="(preview, index) in dataPreviews" :key="index">
      <CardIframeCustom :preview="preview" />
    </el-carousel-item>
  </el-carousel>
</template>
<script>
import CardIframeCustom from "./CardIframeCustom.vue";
export default {
  name: "iframe-conte",
  components: {
    CardIframeCustom
  },
  props: {
    previews: Array
  },
  watch: {
    previews: {
      handler(data) {
        this.dataPreviews = data;
      },
      deep: true
    }
  },
  data() {
    return {
      dataPreviews: []
    };
  }
};
</script>
